import assets from "app/assets";
import config from "config";
import gsap from "gsap";
import { AnimatedSprite, BLEND_MODES, Container, DEG_TO_RAD, Graphics, Point, Sprite } from "pixi.js";
import tools from "tools";
import Particules from "./particules";
import ClickParticles from "./clickParticles";
const LINE_SIZE = config.lineSize;
const LINE_DISTANCE = config.lineDistance;
const COEF_DELTA_INC_VALUE = -3.7;
const BIRD_IDLE_ANIM_SPEED = 0.4;
export default class Bubble extends Container {
  constructor(index, colorData, size) {
    super();
    this.onMove = this.onMove.bind(this);
    this.addNode = this.addNode.bind(this);
    this.drawNode = this.drawNode.bind(this);
    this.onDown = this.onDown.bind(this);
    this.select = this.select.bind(this);
    this.hint = this.hint.bind(this);
    this.explode = this.explode.bind(this);
    this._index = index;
    this._id = null;
    this._root = false;
    this._size = size;
    this._color = colorData.color;
    //this._texture = assets.textures[colorData.texture].texture;
    this._texture = null;
    this._label = colorData.label;
    this._nodeBase = null;
    this.p2 = new Point();

    //white rectangle in the back of the bird
    this.rec_back = new Sprite(assets.textures.rec.texture);
    this.rec_back.anchor.set(.5, .5);
    this.rec_back.width = size * 1.1;
    this.rec_back.height = size * 1.1;
    this.rec_back.alpha = config.backAlpha;
    this.addChild(this.rec_back);
    this.sprite = null;
    this._birdStatic = null;
    this._birdAnim = null;
    this.getBirdTexture();
    this.hallo = new Sprite(assets.textures.bulleHallo.texture);
    this.hallo.tint = this._color;
    this.hallo.anchor.set(.5);
    this.hallo.scale.set(0);
    this.hallo.visible = false;
    this.addChildAt(this.hallo);
    this.bubbleLight = new Graphics();
    this.bubbleLight.beginFill(0xffffff, .5);
    this.bubbleLight.drawCircle(0, 0, size * .7);
    this.bubbleLight.endFill();
    this.bubbleLight.scale.x = .5;
    this.bubbleLight.rotation = -Math.PI * .25;
    this.bubbleLight.x = 50;
    this.bubbleLight.y = -50;
    this.bubbleLight.visible = false;
    this.addChild(this.bubbleLight);
    this.bubbleMask = new Graphics();
    this.bubbleMask.beginFill(0xff0000);
    this.bubbleMask.drawCircle(0, 0, size / 2);
    this.bubbleMask.endFill();
    this.bubbleLight.mask = this.bubbleMask;
    this.addChild(this.bubbleMask);
    this.zone = new Graphics();
    this.zone.beginFill(0x00ffff, 0);
    this.zone.drawCircle(0, 0, this._size * .6);
    this.zone.endFill();
    this.addChild(this.zone);
    this.zone.visible = false;
    this.interactive = true;
    this.buttonMode = true;
    this.access = true;
    this.on('pointerdown', this.onDown);
    this.on('pointermove', this.onMove);
    this.setShadow(config.themeId);
  }
  lightAnim() {
    this.bubbleLight.visible = true;
    this.bubbleLight.x = 50;
    this.bubbleLight.y = -50;
    gsap.to(this.bubbleLight, {
      duration: .7,
      x: -50,
      y: 50,
      ease: "power4.in",
      onComplete: () => {
        this.bubbleLight.visible = false;
      }
    });
  }

  // onToucheMove
  onMove(event) {
    if (config.pause || !config.touchAccess) {
      return;
    }
    if (config.gameOver) {
      return;
    }
    if (config.isDown) {
      this._newPosition = event.data.getLocalPosition(this.parent);
      if (config.interactionManager.hitTest(config.mouse, this)) {
        if (tools.exist(this, config.selectedBubles) && config.currentOverNode != this) {
          if (this._id < config.selectedBubles.length - 1) {
            this.removeBack();
          }
          config.currentOverNode = this;
        }
        if (config.currentNode && config.currentNode != this) {
          this.p0 = {
            x: this.parent.x + config.currentNode.x,
            y: this.parent.y + config.currentNode.y
          };
          this.p1 = {
            x: this.parent.x + this.x,
            y: this.parent.y + this.y
          };
          if (tools.distance(this.p0, this.p1) < LINE_DISTANCE && config.currentNode.label == this.label) {
            !this._root && this.addNode();
            config.currentNode = this;
          }
        }
      }
    }
  }
  onDown(event, fromBonus) {
    config.boosterRvPopin && config.boosterRvPopin.hide();
    // start game and hide ui
    config.ui.start();
    //bomb booster
    if (config.bombBoosterReady) {
      config.bombBoosterReady = false;
      if (!fromBonus) {
        config.boosterMenu.bombVal--;
        config.sdk.getStoreModule().save("bomb", {
          value: config.boosterMenu.bombVal
        });
      }
      this.putTheBomb();
    }
    //hammer booster
    if (config.hammerBoosterReady) {
      config.hammerBoosterReady = false;
      config.boosterMenu.hammerVal--;
      config.sdk.getStoreModule().save("hammer", {
        value: config.boosterMenu.hammerVal
      });
      this.putTheHammer();
    }
    //rocket booster
    if (config.roketBoosterReady) {
      config.roketBoosterReady = false;
      config.boosterMenu.rocketVal--;
      config.sdk.getStoreModule().save("rocket", {
        value: config.boosterMenu.rocketVal
      });
      this.putTheRocket();
    }
    //swap booster
    if (config.swapBoosterReady) {
      config.swapBoosterReady = false;
      config.boosterMenu.swapVal--;
      config.sdk.getStoreModule().save("swap", {
        value: config.boosterMenu.swapVal
      });
      this.putTheSwap();
    }
    if (config.pause || !config.touchAccess) {
      return;
    }
    if (config.gameOver || config.isDown) {
      return;
    }
    config.hintDelayTween && config.hintDelayTween.kill();
    if (config.currentNode != this && config.touchAccess) {
      this._root = true;
      if (event) {
        this._newPosition = event.data.getLocalPosition(this.parent);
      }
      this.access = true;
      config.isDown = true;
      config.currentNode = this;
      config.border.tint = this._color;
      config.selectedBubles.push(this);
      config.border.progress(config.selectedBubles.length);
      this._id = config.selectedBubles.length - 1;
      this.select(true);
      this.rec_back.tint = this._color;
      config.linkSoundId = 0;
      if (config.soundOn) {
        config.AllHowlerAudios["link" + config.linkSoundId].play();
      }

      this.addNode();
    }
  }
  putTheBomb() {
    if (!config.touchAccess) {
      return;
    }
    if (config.soundOn) {
      config.AllHowlerAudios["Bomb_part1_wick"].play();
    }
    config.hintDelayTween && config.hintDelayTween.kill();
    config.boosterPopin.hide();
    config.bomb.visible = true;
    config.bomb.alpha = 1;
    config.bomb.scale.set(1);
    config.bomb.anchor.set(.5);
    config.bomb.position.set(this.x, this.y);
    if (this.parent) {
      this.parent.addChild(config.bomb);
    } else {
      config.Selected_BubblesParent.addChild(config.bomb);
    }
    config.flame.position.set(this.x + 10, this.y - 45);
    config.flame.play();
    if (this.parent) {
      this.parent.addChild(config.flame);
    } else {
      config.Selected_BubblesParent.addChild(config.flame);
    }
    gsap.to(config.bomb.scale, {
      duration: .5,
      x: .6,
      y: .6,
      ease: "back.out(1.5)",
      onComplete: () => {
        config.flame.visible = true;
      }
    });
    config.touchAccess = false;
    config.selectedBubles.push(this);
    this.index.x > 0 && this.index.y > 0 && config.selectedBubles.push(config.bubbles[this.index.x - 1][this.index.y - 1]);
    this.index.y > 0 && config.selectedBubles.push(config.bubbles[this.index.x][this.index.y - 1]);
    this.index.x < 5 && this.index.y > 0 && config.selectedBubles.push(config.bubbles[this.index.x + 1][this.index.y - 1]);
    this.index.x > 0 && config.selectedBubles.push(config.bubbles[this.index.x - 1][this.index.y]);
    this.index.x < 5 && config.selectedBubles.push(config.bubbles[this.index.x + 1][this.index.y]);
    this.index.x > 0 && this.index.y < 5 && config.selectedBubles.push(config.bubbles[this.index.x - 1][this.index.y + 1]);
    this.index.y < 5 && config.selectedBubles.push(config.bubbles[this.index.x][this.index.y + 1]);
    this.index.x < 5 && this.index.y < 5 && config.selectedBubles.push(config.bubbles[this.index.x + 1][this.index.y + 1]);
    for (var i = 0; i < config.selectedBubles.length; i++) {
      config.selectedBubles[i].dispose(true, config.bombDelay, false);
    }
    gsap.delayedCall(config.bombDelay * 0.5, () => {
      if (config.soundOn) {
        config.AllHowlerAudios["Bomb_part1_wick"].stop();
      }
      if (config.soundOn) {
        config.AllHowlerAudios["Bomb_part2_explode"].play();
      }
    });
    gsap.delayedCall(config.bombDelay, () => {
      gsap.to(config.bomb.scale, {
        duration: .3,
        x: 1,
        y: 1
      });
      gsap.to(config.bomb, {
        duration: .3,
        alpha: 0,
        onComplete: () => {
          config.bomb.visible = false;
          config.flame.visible = false;
          config.flame.stop();
        }
      });
    });

    //score calucl
    let delay = config.selectedBubles.length;
    config.selectedBubles = [];
    config.currentScore = config.ui.score + delay + config.scoreMultiplier + COEF_DELTA_INC_VALUE;
    gsap.delayedCall(config.bombDelay + .2, () => {
      for (let k = 0; k < 6; k++) {
        config.level.addNewBubblesProcess(k);
      }
      gsap.to(config.ui, {
        duration: .4,
        score: config.currentScore
      });
      config.header.updateScore(config.currentScore * config.scoreCoef);
      if (delay >= config.bonusScore) {
        config.ui.stars.show();
        config.ui.scoreTextObj.scale.set(1.3);
        gsap.to(config.ui.scoreTextObj.scale, {
          duration: .4,
          x: 1,
          y: 1
        });
      }
      config.scoreMultiplier = 1;
      config.touchAccess = true;
      config.level.checkScore();
      if (!config.gameOver) {
        delay < 9 && (config.touchAccess = true);
      } else {
        config.ui.saveScore(config.currentScore);
      }
    });
  }
  putTheRocket() {
    if (!config.touchAccess) {
      return;
    }
    config.hintDelayTween && config.hintDelayTween.kill();
    config.boosterPopin.hide();
    config.touchAccess = false;
    config.level.destroyBubblesFromPoint(this.index.x, this.index.y, true);
  }
  putTheSwap() {
    if (!config.touchAccess) {
      return;
    }
    config.hintDelayTween && config.hintDelayTween.kill();
    config.boosterPopin.hide();
    config.touchAccess = false;
    config.level.swapBubbles();
  }
  putTheHammer() {
    if (!config.touchAccess) {
      return;
    }
    config.hintDelayTween && config.hintDelayTween.kill();
    config.boosterPopin.hide();
    this.parent.addChild(config.hammer);
    config.hammer.visible = true;
    config.hammer.scale.set(1.5);
    config.hammer.anchor.set(.5);
    config.hammer.position.set(this.x, this.y);
    config.hammer.alpha = 1;
    config.hammer.rotation = 0;
    config.touchAccess = false;
    config.bubbles.forEach(A => {
      A.forEach(b => {
        config.selectedBubles.push(b);
      });
    });
    for (var i = 0; i < config.selectedBubles.length; i++) {
      config.selectedBubles[i].dispose(true, config.hammerDelay, false);
    }
    gsap.delayedCall(config.hammerDelay * 0.75, () => {
      if (config.soundOn) {
        config.AllHowlerAudios["bonus_hammer"].play();
      }
    });
    gsap.delayedCall(config.hammerDelay, () => {
      gsap.to(config.hammer.scale, {
        duration: 0.6,
        x: 0.1,
        y: 0.1
      });
      gsap.to(config.hammer, {
        duration: 0.6,
        rotation: -Math.PI
      });
      gsap.to(config.hammer, {
        duration: 0.9,
        alpha: 0,
        onComplete: () => {
          config.hammer.visible = false;
        }
      });
    });
    setTimeout(() => {
      this.parent.removeChild(config.hammer);
    }, config.hammerDelay * 1000 * 1.2);

    //score calucl
    let delay = config.selectedBubles.length;
    config.selectedBubles = [];
    config.currentScore = config.ui.score + delay + config.scoreMultiplier + COEF_DELTA_INC_VALUE;
    gsap.delayedCall(config.hammerDelay + .2, () => {
      for (let k = 0; k < 6; k++) {
        config.level.addNewBubblesProcess(k);
      }
      gsap.to(config.ui, {
        duration: .4,
        score: config.currentScore
      });
      config.header.updateScore(config.currentScore * config.scoreCoef);
      if (delay >= config.bonusScore) {
        config.ui.stars.show();
        config.ui.scoreTextObj.scale.set(1.3);
        gsap.to(config.ui.scoreTextObj.scale, {
          duration: .4,
          x: 1,
          y: 1
        });
      }
      config.scoreMultiplier = 1;
      config.touchAccess = true;
      config.level.checkScore();
      if (!config.gameOver) {
        delay < 9 && (config.touchAccess = true);
      } else {
        config.ui.saveScore(config.currentScore);
      }
    });
  }
  addNode() {
    if (!this._nodeBase && this.access && config.currentNode.label == this.label) {
      this.addParticlesOnClick(this._color);
      config.lineColor = tools.hexaToHashtag(tools.darkenColor(this._color, .7));
      this._nodeBase = config.web.addNode();
      if (config.currentNode.access) {
        this.p0 = {
          x: this.parent.x + config.currentNode.x,
          y: this.parent.y + config.currentNode.y
        };
        this.p1 = {
          x: this.parent.x + this.x,
          y: this.parent.y + this.y
        };
        let g = config.currentNode.graphics;
        this.drawNode(g, this.p0, this.p1, tools.distance(this.p0, this.p1));
        if (config.currentNode != this) {
          /* this._nodeBase.beginFill(tools.hashtagToHexa(config.lineColor));
            this._nodeBase.drawCircle(this.p1.x, this.p1.y, this._size / 2 + 5);
           this._nodeBase.endFill();*/

          config.currentNode.access = false;
          config.currentNode = this;
          config.selectedBubles.push(this);
          config.Selected_Bubbles = this;
          config.Selected_BubblesParent = this.parent;
          config.border.progress(config.selectedBubles.length);
          this._id = config.selectedBubles.length - 1;
          this.select(true);
          this.rec_back.tint = this._color;
          if (config.linkSoundId < 9) {
            config.linkSoundId++;
          }
          if (config.soundOn) {
            config.AllHowlerAudios["link" + config.linkSoundId].play();
          }
        }
      }
    }
  }
  addParticlesOnClick(tint) {
    let p = {
      x: this.parent.x + this.x,
      y: this.parent.y + this.y
    };
    new ClickParticles(tint, {
      x: p.x,
      y: p.y
    }, 8, config.particulesContainer, 100, .5);
  }
  drawNode(g, p0, p1, distance) {
    if (!g) {
      return;
    }
    g.clear();
    g.lineStyle(LINE_SIZE, tools.hashtagToHexa(config.lineColor), 1, 0.5);
    this.drawStrippyLine(g, p0, p1);
    g.alpha = config.lineAlpha;
  }
  drawStrippyLine(g, p1, p2) {
    const dashLength = 10;
    const gapLength = 5;
    // Calculate distance and angle
    const dx = p2.x - p1.x;
    const dy = p2.y - p1.y;
    const distance = Math.sqrt(dx * dx + dy * dy);
    const angle = Math.atan2(dy, dx);
    let currentDistance = 0;
    while (currentDistance < distance) {
      // Start of the dash
      const startX = p1.x + Math.cos(angle) * currentDistance;
      const startY = p1.y + Math.sin(angle) * currentDistance;
      currentDistance += dashLength;
      if (currentDistance > distance) currentDistance = distance;
      // End of the dash
      const endX = p1.x + Math.cos(angle) * currentDistance;
      const endY = p1.y + Math.sin(angle) * currentDistance;
      g.moveTo(startX, startY);
      g.lineTo(endX, endY);
      // Add the gap
      currentDistance += gapLength;
    }
  }
  get graphics() {
    return this._nodeBase;
  }
  _setBirdAnimPlaying(playing) {
    if (!this._birdAnim || !this._birdStatic) {
      return;
    }
    if (playing) {
      this._birdStatic.visible = false;
      this._birdAnim.visible = true;
      this._birdAnim.play();
    } else {
      this._birdAnim.stop();
      this._birdAnim.gotoAndStop(0);
      this._birdAnim.visible = false;
      this._birdStatic.visible = true;
    }
  }
  select(val) {
    if (!this.visible) {
      return;
    }
    if (val) {
      this._setBirdAnimPlaying(true);
      //this.sprite.scale.set(this._currentScale * .95);
      this.selectAnimeTween && this.selectAnimeTween.kill();
      // this.selectAnimeTween = gsap.to(this.sprite.scale, {
      //   duration: .15,
      //   yoyo: true,
      //   repeat: -1,
      //   x: this._currentScale * 1.25,
      //   y: this._currentScale * 1.25,
      //   ease: "none"
      // });
    } else {
      this._setBirdAnimPlaying(false);
      // this.selectAnimeTween && this.selectAnimeTween.kill();
      // this.selectAnimeTween = gsap.to(this.sprite.scale, {
      //   duration: .3,
      //   x: this._currentScale,
      //   y: this._currentScale
      // });
    }
  }
  hint(val) {
    if (!this.visible) {
      return;
    }
    if (val) {
      //this.sprite.scale.set(this._currentScale);
      this.hintAnimeTween && this.hintAnimeTween.kill();
      // this.hintAnimeTween = gsap.to(this.sprite.scale, {
      //   duration: .35,
      //   yoyo: true,
      //   repeat: -1,
      //   x: this._currentScale * 1.2,
      //   y: this._currentScale * 1.2,
      //   ease: "none"
      // });
    } else {
      this.hintAnimeTween && this.hintAnimeTween.kill();
      // this.hintAnimeTween = gsap.to(this.sprite.scale, {
      //   duration: .4,
      //   x: this._currentScale,
      //   y: this._currentScale
      // });
    }
  }
  removeBack() {
    let i = 0;
    for (i = config.selectedBubles.length - 1; i > this._id; i--) {
      config.selectedBubles[i].dispose();
      config.selectedBubles.splice(i, 1);
      config.border.progress(config.selectedBubles.length);
      if (config.linkSoundId > 0) {
        config.linkSoundId--;
      }
    }
    config.currentNode = config.selectedBubles[config.selectedBubles.length - 1];
    config.currentNode.access = true;
    if (config.soundOn) {
      config.AllHowlerAudios["link" + config.linkSoundId].play();
    }
  }
  removeNode() {
    if (this._nodeBase) {
      this._nodeBase.parent && this._nodeBase.parent.removeChild(this._nodeBase);
      this._nodeBase && this._nodeBase.clear();
      // this._nodeBase && this._nodeBase.destroy(true);
      this._nodeBase = null;
    }
  }

  //Color
  get label() {
    return this._label;
  }
  get destroyed() {
    return this._destroyed;
  }
  get index() {
    return this._index;
  }
  set skin(data) {
    this._themeId = data.id;
    this.setShadow(this._themeId);
    this._color = data.tint;
    this._texture = assets.textures[data.texture].texture;

    /* this.sprite.texture = this._texture;
     this.sprite.tint = this._color;*/
    this.hallo.tint = this._color;
    this.getBirdTexture();
    // this.sprite.tint = this._color;
  }
  setShadow(id) {
    /*
    if (id == 0 || id == 7 || id == 8) {
        this.rec_back.visible = false;
    } else {
        this.rec_back.visible = true;
    }*/
  }
  explode(delay, fromMissile) {
    this._destroyed = true;
    let __y = this.y;
    let time = .05;
    let bubblesDelay = .6; // delais correspend à 10 bulles
    let decalY = 1 - delay / bubblesDelay;
    gsap.to(this, {
      delay: delay * .8,
      duration: fromMissile ? 0 : time,
      y: __y - 12 * (decalY >= 0 ? decalY : 0),
      onComplete: () => {
        gsap.to(this, {
          duration: fromMissile ? 0 : time,
          y: __y,
          onComplete: () => {
            gsap.delayedCall(delay * .2, () => {
              if (!fromMissile) {
                if (config.soundOn) {
                  config.AllHowlerAudios.Matching_s.play();
                }
              }
              this.hallo.visible = true;
              gsap.to(this.hallo.scale, {
                duration: .4,
                x: 1,
                y: 1,
                onComplete: () => {
                  this.hallo.destroy();
                  this.parent && this.parent.removeChild(this);
                  this.visible = false;
                },
                ease: "Power4.out"
              });
              gsap.to(this.hallo, {
                delay: .2,
                duration: .2,
                alpha: 0
              });
              this.particules && this.particules.animate();
              this._birdAnim && this._birdAnim.stop();
              this.sprite.visible = false;
              this.zone && this.zone.clear();
              this.bubbleLight && this.bubbleLight.clear();
              this.bubbleMask && this.bubbleMask.clear();

              // genere bug
              // setTimeout(() => {
              //     this.destroy({
              //         children: true
              //         // texture: true,
              //         // baseTexture: true
              //     });
              // }, 2000);
            });
          }
        });
      }
    });
  }
  reset() {
    this.selectAnimeTween && this.selectAnimeTween.kill();
    this.hintShadowAnimeTween && this.hintShadowAnimeTween.kill();
    this.removeNode();
    this.access = true;
    this._root = false;
    this.select(false);
    this.rec_back.tint = 0xffffff;
  }
  dispose(destroy, delay, fromMissile = false, showTrail = false) {
    config.border.clearAll();
    this.rec_back.tint = 0xffffff;
    if (destroy && this.parent) {
      this.off('pointerdown', this.onDown);
      this.off('pointerover', this.onMove);
      let p = {
        x: this.parent.x + this.x,
        y: this.parent.y + this.y
      };
      let nbrCoef = 1;
      this.particules = new Particules(this._color, {
        x: p.x,
        y: p.y
      }, 30 / nbrCoef, config.particulesContainer, 5, 1);

      // this.particules.force = new Point(1.038, 1.058);
      // this.particules.gravity = new Point(0, .000175 * nbrCoef);
      this.particules.force = new Point(1.038, 1.05);
      this.particules.gravity = new Point(0, .00006 * nbrCoef);
      this.explode(delay, fromMissile);
      if (config.defaultObjectif.active) {
        gsap.delayedCall(delay, () => {
          let exist = config.defaultObjectif.labelExist(this._label);
          exist.label && this.getPoint(this._label, exist.labelPos, p, showTrail);
          this.getPoint(exist.universal, exist.universalPos, p, showTrail);
        });
      }
    }
    this.removeNode();
    this.access = true;
    this._root = false;
    this.select(false);
  }
  getPoint(label, pos, p, showTrail) {
    if (label) {
      let destPos = new Point();
      destPos.x = config.defaultObjectif.x + pos.x;
      destPos.y = config.defaultObjectif.y + pos.y - 30;
      let g = new Graphics();
      g.beginFill(this._color);
      g.drawCircle(0, 0, 15);
      g.endFill();
      g.x = p.x;
      g.y = p.y;
      showTrail && config.containerParticules.addChild(g);
      let trail = new Sprite(assets.textures.trail.texture);
      trail.anchor.set(.5, -.2);
      trail.tint = this._color;
      trail.alpha = .8;
      trail.scale.y = 0;
      let angle = tools.pos2angle(p, destPos) - 90;
      trail.rotation = angle * DEG_TO_RAD;
      showTrail && g.addChild(trail);
      let time = .6;
      gsap.to(g, {
        delay: .2,
        duration: time,
        x: destPos.x,
        y: destPos.y,
        ease: "power1.in",
        onComplete: (point, label) => {
          config.defaultObjectif.achievedBubble(label, this._color);
          point.destroy();
        },
        onCompleteParams: [g, label]
      });
      gsap.to(trail.scale, {
        delay: .2,
        duration: time,
        y: 1
      });
    }
  }
  disposeForSwap() {
    this._birdAnim && this._birdAnim.stop();
    this.off('pointerdown', this.onDown);
    this.off('pointerover', this.onMove);
    this.removeNode();
    this.access = true;
    this._root = false;
    this.select(false);
    gsap.to(this.scale, {
      duration: .2,
      x: 0,
      y: 0,
      onComplete: () => {
        this.sprite.visible = false;
        this.parent && this.parent.removeChild(this);
        this.visible = false;
        this.zone && this.zone.clear();
        this.bubbleLight && this.bubbleLight.clear();
        this.bubbleMask && this.bubbleMask.clear();
        gsap.delayedCall(2, () => {
          this.destroy({
            children: true
          });
        });
      }
    });
  }
  update() {
    if (!this.visible) {
      return;
    }
    if (this._nodeBase && this._newPosition && this.access) {
      this.p2.set(this._newPosition.x + config.web.x + this.parent.x, this._newPosition.y + config.web.y + this.parent.y);
      let dist = tools.distance(this.p1, this.p2);
      this.drawNode(this._nodeBase, this.p1, this.p2, dist < LINE_DISTANCE ? dist : LINE_DISTANCE);
    }
  }
  getBirdFramesForColor() {
    if (!config.Bframes || !config.Bframes.length) {
      return null;
    }
    if (this._color == "0xf98c29") {
      return config.Yframes;
    }
    if (this._color == "0xff001d") {
      return config.Rframes;
    }
    if (this._color == "0x5282f6") {
      return config.Bframes;
    }
    if (this._color == "0x4dba30") {
      return config.Gframes;
    }
    if (this._color == "0x962beb") {
      return config.Vframes;
    }
    return config.Mframes;
  }
  getBirdStaticTexture() {
    if (this._color == "0xf98c29") {
      return assets.textures.bo.texture;
    }
    if (this._color == "0xff001d") {
      return assets.textures.br.texture;
    }
    if (this._color == "0x5282f6") {
      return assets.textures.bb.texture;
    }
    if (this._color == "0x4dba30") {
      return assets.textures.bg.texture;
    }
    if (this._color == "0x962beb") {
      return assets.textures.bv.texture;
    }
    return assets.textures.bm.texture;
  }
  getBirdTexture() {
    const frames = this.getBirdFramesForColor();
    let insertIndex = 1;
    if (this.sprite) {
      insertIndex = this.getChildIndex(this.sprite);
      this._birdAnim && this._birdAnim.stop();
      this.removeChild(this.sprite);
      this.sprite.destroy({
        children: true,
        texture: false,
        baseTexture: false
      });
      this.sprite = null;
      this._birdStatic = null;
      this._birdAnim = null;
    }
    const wrap = new Container();
    const st = new Sprite(this.getBirdStaticTexture());
    st.anchor.set(.5);
    st.width = this._size;
    st.height = this._size;
    wrap.addChild(st);
    this._birdStatic = st;
    this._birdAnim = null;
    if (frames && frames.length > 1) {
      const anim = new AnimatedSprite(frames);
      anim.anchor.set(.5);
      anim.width = this._size;
      anim.height = this._size;
      anim.loop = true;
      anim.animationSpeed = BIRD_IDLE_ANIM_SPEED;
      anim.gotoAndStop(0);
      anim.visible = false;
      wrap.addChild(anim);
      this._birdAnim = anim;
    }
    this.sprite = wrap;
    this._currentScale = st.scale.x;
    this.addChildAt(this.sprite, Math.min(insertIndex, this.children.length));
  }
}
